/** Promo tile illustration of Daniel Reinert (RP homepage, KM dashboard). */
export const DANIEL_REINERT_PROMO_IMAGE = require("./images/daniel_reinert_promo.png");
export const DANIEL_REINERT_PROMO_IMAGE_NO_BACKGROUND = require("./images/daniel_reinert_promo_no_background.png");
/** Promo tile illustration of Daniel Reinert (RP homepage, KM dashboard). */
export const DANIEL_REINERT_PROMO_IMAGE = require("./images/daniel_reinert_promo.png");
export const DANIEL_REINERT_PROMO_IMAGE_NO_BACKGROUND = require("./images/daniel_reinert_promo_no_background.png");
